import {required} from "@Common/react/cs-form-2/validators/required";

export const formFields = [
    {
        path: ["cardHolderName"],
        validators: [required],
    },
    {
        path: ["streetAddress"],
        validators: [required],
    },
    {
        path: ["city"],
        validators: [required],
    },
    {
        path: ["stateProvince"],
        validators: [required],
    },
    {
        path: ["country"],
        validators: [required],
    },
    {
        path: ["zip"],
        validators: [required],
    },
];